/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tokens_ActiveInputs */

const en_tokens_active = /** @type {(inputs: Tokens_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active tokens`)
};

const de_tokens_active = /** @type {(inputs: Tokens_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive Tokens`)
};

/**
* | output |
* | --- |
* | "Active tokens" |
*
* @param {Tokens_ActiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tokens_active = /** @type {((inputs?: Tokens_ActiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tokens_ActiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tokens_active(inputs)
	return en_tokens_active(inputs)
});